export default [
    {
        path: '/marketing/mantenimiento/bodega',
        name: 'marketing-mantenimiento-bodega',
        component: () => import('@/views/pages/marketing/mantenimiento/Bodega.vue'),
        meta: {
            title: 'i18n:marketing.mantenimiento.bodega.title',
            resource: 'Marketing',
            action: 'ver-marketing-mantenimiento-bodega',
            pageTitle: 'marketing.mantenimiento.bodega.title',
            breadcrumb: [
                {
                    text: 'marketing.title',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'marketing.mantenimiento.bodega.title',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/marketing/mantenimiento/categoria',
        name: 'marketing-mantenimiento-categoria',
        component: () => import('@/views/pages/marketing/mantenimiento/Categoria.vue'),
        meta: {
            title: 'i18n:marketing.mantenimiento.categoria.title',
            resource: 'Marketing',
            action: 'ver-marketing-mantenimiento-categoria',
            pageTitle: 'marketing.mantenimiento.categoria.title',
            breadcrumb: [
                {
                    text: 'marketing.title',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'marketing.mantenimiento.categoria.title',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/marketing/mantenimiento/item',
        name: 'marketing-mantenimiento-item',
        component: () => import('@/views/pages/marketing/mantenimiento/Item.vue'),
        meta: {
            title: 'i18n:marketing.mantenimiento.item.title',
            resource: 'Marketing',
            action: 'ver-marketing-mantenimiento-item',
            pageTitle: 'marketing.mantenimiento.item.title',
            breadcrumb: [
                {
                    text: 'marketing.title',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'marketing.mantenimiento.item.title',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/marketing/transacciones/inventario',
        name: 'marketing-transacciones-inventario',
        component: () => import('@/views/pages/marketing/transacciones/Inventario.vue'),
        meta: {
            title: 'i18n:marketing.transacciones.inventario.title',
            resource: 'Marketing',
            action: 'ver-marketing-transacciones-inventario',
            pageTitle: 'marketing.transacciones.inventario.title',
            breadcrumb: [
                {
                    text: 'marketing.title',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'marketing.transacciones.inventario.title',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/marketing/transacciones/aprobar-egresos',
        name: 'marketing-transacciones-aprobar-egresos',
        component: () => import('@/views/pages/marketing/transacciones/AprobarEgresos.vue'),
        meta: {
            title: 'i18n:marketing.transacciones.aprobar-egresos.title',
            resource: 'Marketing',
            action: 'ver-marketing-transacciones-aprobar-egresos',
            pageTitle: 'marketing.transacciones.aprobar-egresos.title',
            breadcrumb: [
                {
                    text: 'marketing.title',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'marketing.transacciones.aprobar-egresos.title',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/marketing/informes/kardex',
        name: 'marketing-informes-kardex',
        component: () => import('@/views/pages/marketing/informes/Kardex.vue'),
        meta: {
            title: 'i18n:marketing.informes.kardex.title',
            resource: 'Marketing',
            action: 'ver-marketing-informes-kardex',
            pageTitle: 'marketing.informes.kardex.title',
            breadcrumb: [
                {
                    text: 'marketing.title',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'marketing.informes.kardex.title',
                    active: true,
                },
            ],
        },
    },
]
